<template>
  <div>
    <div class="container-page-header">
      <van-tabbar v-model="active">
        <van-tabbar-item @click="goToApply">
          <span>我的报修</span>
          <template #icon="props">
            <img src="../../../assets/image/repair/repair/repair-one.png" :class="props.active"/>
          </template>
        </van-tabbar-item>
        <van-tabbar-item @click="goToRepair">
          <span>我的维修</span>
          <template #icon="props">
            <img src="../../../assets/image/repair/repair/repair-two-active.png" :class="props.active"/>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>

    <div class="container-page-body">
      <div class="pages-search">
        <div class="pages-search-checkbox">
          <van-checkbox v-model="checked" @click="getMyList">我维修的</van-checkbox>
        </div>
        <div class="pages-search-popup">
          <img class="search-img" src="../../../assets/image/repair/icon_nav_saoyisao@2x.png"
               @click="alertSearchMenu">
          <van-popup
              :close-on-click-overlay="false"
              v-model:show="show"
              round
              position="bottom"
              :style="{ height: '58%' }"
              class="popup-search">
            <div class="popup-search-header">
              <div class="popup-search-header__empty"></div>
              <div class="popup-search-header__title">筛选</div>
              <div class="popup-search-header__cancel" @click="toCancel">取消</div>
            </div>
            <div class="popup-search-body">
              <div class="popup-search-body__status">
                <div class="popup-search-body__status-info">报修类型</div>
                <div class="popup-search-body__status-select">
                  <van-skeleton
                      :row="2"
                      :loading="loading"
                      animate
                      round
                      :style="'padding:10px'"
                  >
                    <div
                        :class="['popup-search-body__status-option', {'option-active':item.id===tmpParams.repairType}]"
                        v-for="(item, index) in searchForm.typeList"
                        :key="index"
                        @click="operateType(item)">{{ item.name }}
                    </div>
                  </van-skeleton>
                </div>
              </div>
              <div class="popup-search-body__status">
                <div class="popup-search-body__status-info">维修状态</div>
                <div class="popup-search-body__status-select">
                  <div
                      :class="['popup-search-body__status-option', {'option-active':item.key===tmpParams.repairStatus}]"
                      v-for="(item, index) in searchForm.statusList"
                      :key="index"
                      @click="operateStatus(item)">{{ item.title }}
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-search-footer">
              <div class="popup-search-footer__button button-reset" @click="buttonReset">重置</div>
              <div class="popup-search-footer__button button-confirm" @click="buttonConfirm">确定</div>
            </div>
          </van-popup>
        </div>
      </div>
      <div class="pages-list">
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="0"
            @load="getList"
        >
          <div class="pages-item"
               v-for="(item, index) in tableData.list"
               :key="index"
               @click="getDetail(item)">
            <div class="pages-item-title">
              <!-- <div class="pages-item-title-img">
                <img src="../../../assets/image/repair/icon_nav_saoyisao@2x.png">
              </div>-->
              <div class="pages-item-title-content">由{{ item.applyUserName }}申请的报修</div>
              <div class="pages-item-title-date">
                {{ item.createTime ? item.createTime.substr(0, item.createTime.length - 3) : '' }}
              </div>
            </div>
            <div class="pages-item-body">
              <div class="pages-item-body-info">
                <div class="info-icon"
                     :style="'background-color: '+
                     (dictInfo.statusList[item.repairStatus] ? dictInfo.statusList[item.repairStatus].backgroundColor:'#cccccc')+';'">
                  <span class="info-icon-right">
                  {{
                      dictInfo.statusList[item.repairStatus] ? dictInfo.statusList[item.repairStatus].name : item.repairStatus
                    }}
                  </span>
                </div>
                <div class="info-desc">{{ item.repairTypeName }}</div>
              </div>
              <div class="pages-item-body-content">
                <div class="info-field">报修地址：</div>
                <div class="info-value">{{ item.repairAddress }}</div>
              </div>
              <div class="pages-item-body-content">
                <div class="info-field">报修内容：</div>
                <div class="info-value">{{ item.msg }}</div>
              </div>
            </div>
            <div class="pages-item-footer">
              <div class="pages-item-body-allocate" v-show="item.isCanDistribute && item.repairStatus==='0'">
                <div class="button-allocate" @click.stop="buttonAllocate(item)">分配维修员</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {Skeleton, Tab, Tabbar, TabbarItem, Tabs, Loading, Toast} from "vant";

export default {
  components: {
    [Skeleton.name]: Skeleton,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Loading.name]: Loading,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let active = ref(1);
    let loading = ref(false);
    let finished = ref(false);
    let refreshing = ref(false);
    let show = ref(false);
    let dictInfo = ref({
      statusList: {
        underway: {backgroundColor: '#FF8948', name: '审批中'},
        refuse: {backgroundColor: '#f50b27', name: '已拒绝'},
        agree: {backgroundColor: '#4174FD', name: '已同意'},
        revoke: {backgroundColor: '#cccccc', name: '已撤消'},
        0: {backgroundColor: '#FF8948', name: '待分配'},
        1: {backgroundColor: '#4174FD', name: '维修中'},
        2: {backgroundColor: '#00C73D', name: '维修完成'},
      },
    });
    let searchForm = ref({
      typeList: [],
      statusList: [
        {
          key: 'underway',
          title: '审批中',
        },
        {
          key: 'refuse',
          title: '已拒绝',
        },
        {
          key: 'agree',
          title: '已同意',
        },
        {
          key: 'revoke',
          title: '已撤消',
        },
        {
          key: '0',
          title: '待分配',
        },
        {
          key: '1',
          title: '维修中',
        },
        {
          key: '2',
          title: '维修完成',
        },
      ],
    })
    let tableData = ref({
      list: [],
      total: 0,
    });
    let tmpParams = ref({
      repairStatus: '',
      repairType: '',
    });
    let checked = ref(false); // 我维修的
    let queryParams = ref({
      menuType: 'maintain',
      selfFlag: '', // 是否是我维修的
      repairType: '', // 报修类型
      repairStatus: '', // 报修状态
      pageNum: 1,
      pageSize: 10,
    });

    const filterObj = (obj) => {
      for (const i in obj) {
        if (obj[i] === '' || obj[i] === null || obj[i] === 'null') {
          delete obj[i]
        }
      }
      return obj;
    };

    const getDictionaryListApi = (params) => store.dispatch("repair/getDictionaryList", params);

    const getDictList = async (type) => {
      let searchName;
      if (type === 1) {
        searchName = "报修类型";
      }
      let r = await getDictionaryListApi({
        dictionaryTypeName: searchName,
      });
      if (r.message == "success") {
        if (type === 1) {
          searchForm.value.typeList = r.data.list;
        }
      }
    };

    // 我的维修-列表接口
    const getRecordListApi = (params) => store.dispatch("repair/getRecordList", params);

    const getList = async () => {
      loading.value = true;

      if (refreshing.value) {
        queryParams.value.pageNum = 1;
        tableData.value.list = [];
        refreshing.value = false;
      }

      let r = await getRecordListApi({
        ...filterObj(queryParams.value)
      });

      if (r.message == "success") {
        tableData.value.total = r.data.total;
        tableData.value.list = tableData.value.list.concat(r.data.list);
        queryParams.value.pageNum ++;
      } else {
        Toast.fail(r.message);
      }

      loading.value = false;
      if (!r.data || r.data.list.length < queryParams.value.pageSize) {
        finished.value = true;
      }
    };

    const getMyList = () => {
      if (loading.value) {
        checked.value = false;
        Toast.fail('页面加载中');
      } else {
        refreshing.value = true;
        queryParams.value.selfFlag = checked.value === true ? 1 : '';
        getList();
      }
    };
    const getDetail = (item) => {
      router.push(`/repair/report/serviceDetail?id=` + item.id)
    };
    const toCancel = () => {
      show.value = false;
      tmpParams.value.repairType = queryParams.value.repairType;
      tmpParams.value.repairStatus = queryParams.value.repairStatus;
    };
    const alertSearchMenu = () => {
      show.value = true;
    };
    const operateType = (item) => {
      console.log('选择维修类型')
      tmpParams.value.repairType = item.id;
    };
    const operateStatus = (item) => {
      console.log('选择维修状态')
      tmpParams.value.repairStatus = item.key;
    };
    const buttonReset = () => {
      if (loading.value) {
        Toast.fail('页面加载中');
        return;
      }
      // 清理查询数据
      queryParams.value.repairType = '';
      queryParams.value.repairStatus = '';
      tmpParams.value.repairType = '';
      tmpParams.value.repairStatus = '';
      console.log('buttonReset请求接口', queryParams.value.repairStatus)
      refreshing.value = true;
      getList();
      show.value = false;
    };
    const buttonConfirm = () => {
      if (loading.value) {
        Toast.fail('页面加载中');
        return;
      }
      if (tmpParams.value.repairType === '' && tmpParams.value.repairStatus === '') {
        Toast.fail('筛选条件不能为空');
      } else {
        queryParams.value.repairType = tmpParams.value.repairType;
        queryParams.value.repairStatus = tmpParams.value.repairStatus;
        console.log('buttonConfirm请求接口', queryParams.value.repairType, queryParams.value.repairStatus)
        refreshing.value = true;
        getList();
        show.value = false;
      }
    };
    const buttonAllocate = (item) => {
      console.log('分配维修员', item);
      router.push(`/repair/report/serviceAllocate?id=` + item.id);
    };

    const goToApply = () => {
      if (router.currentRoute.value.path !== '/repair/report/apply' ||
          router.currentRoute.value.path !== '/repair/report/audit' ||
          router.currentRoute.value.path !== '/repair/report/record') {
        console.log(router.currentRoute.value.path);
        router.push('/repair/report/apply').catch(err => {
          console.log('跳转异常：', err)
        });
      }
    };
    const goToRepair = () => {
      if (router.currentRoute.value.path !== '/repair/report/service') {
        console.log(router.currentRoute.value.path);
        router.push(`/repair/report/service`).catch(err => {
          console.log('跳转异常：', err)
        });
      }
    };

    onMounted(() => {
      getDictList(1);
    })

    return {
      loading,
      finished,
      refreshing,
      show,
      dictInfo,
      searchForm,
      tableData,
      tmpParams,
      checked,
      queryParams,
      active,

      filterObj,
      getDictList,
      getList,
      getMyList,
      getDetail,
      toCancel,
      alertSearchMenu,
      operateType,
      operateStatus,
      buttonReset,
      buttonConfirm,
      buttonAllocate,
      goToApply,
      goToRepair,
    };
  },
};
</script>
<style lang="less" scoped>
.container-page-body {
  background-color: #F2F4FA;

  .pages-search {
    width: 100%;
    position: fixed;
    z-index: 900;
    height: 44px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;

    .pages-search-checkbox {
      font-size: 15px;
    }

    .pages-search-popup {
      width: 42px;

      .search-img {
        width: 24px;
      }
    }

  }

  .pages-list {
    padding: 75px 10px 50px;
    min-height: 595px;

    .pages-item {
      background-color: #FFFFFF;
      margin-bottom: 8px;
      border-radius: 10px;

      .pages-item-title {
        color: #999999;
        font-size: 13px;
        padding: 0 12px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #E5E5E5;

        .pages-item-title-img img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .pages-item-title-content {
          width: 188px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .pages-item-body {
        padding: 12px;

        .pages-item-body-info {
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 12px;

          .info-icon {
            display: inline-block;
            width: 74px;
            height: 24px;
            line-height: 24px;
            background-color: #FF8948;
            font-size: 13px;
            text-align: center;
            transform: skewX(-15deg);
            border-radius: 2px;
            color: #FFFFFF;

            .info-icon-right {
              display: inline-block;
              transform: skewX(15deg);
            }
          }

          .info-desc {
            margin-left: 10px;
            font-size: 17px;
            color: #333333;
          }

        }

        .pages-item-body-content {
          color: #666666;
          font-size: 15px;
          margin-top: 10px;

          .info-field {
            width: 80px;
            height: 20px;
            float: left;
          }

          .info-value {
            display: table;
          }
        }
      }

      .pages-item-footer {
        padding: 0 12px;

        .pages-item-body-allocate {
          border-top: 1px solid #E5E5E5;
          text-align: center;

          .button-allocate {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #4174FD;
            font-size: 15px;
          }
        }
      }
    }
  }

  .popup-search {
    .popup-search-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
      margin-bottom: 10px;

      .popup-search-header__empty {
        width: 40px;
        height: 54px;
        line-height: 54px;
      }

      .popup-search-header__title {
        height: 54px;
        line-height: 54px;
        font-weight: 500;
        text-align: center;
        font-size: 17px;
        color: #333333;
      }

      .popup-search-header__cancel {
        height: 54px;
        line-height: 54px;
        width: 40px;
        padding: 0 10px;
        font-size: 15px;
        color: #333333;
      }
    }

    .popup-search-body {
      width: 100%;
      min-height: 200px;
      border-bottom: 1px solid #E5E5E5;
      margin-bottom: 12px;

      .popup-search-body__status {
        position: relative;
        margin: 0 6px 15px;

        .popup-search-body__status-info {
          padding: 0 12px;
          color: #999999;
          font-size: 15px;
          margin-bottom: 10px;
        }

        .popup-search-body__status-select {
          width: 100%;
          overflow: hidden;
          font-size: 13px;

          .popup-search-body__status-option {
            float: left;
            border: 1px solid #f3f4fb;
            background-color: #f3f4fb;
            color: #333333;
            width: 110px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 36px;
            margin: 5px 4px;
          }

          .option-active {
            border: 1px solid #4275FD;
            background-color: #dae4fe;
            color: #4275FD;
          }

        }

      }
    }

    .popup-search-footer {
      clear: both;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;

      .popup-search-footer__button {
        padding: 10px 70px;
        border: 1px solid #4174FD;
        border-radius: 20px;
        font-size: 15px;
      }

      .button-reset {
        color: #4275FD;
        background-color: #ffffff;
      }

      .button-confirm {
        color: #ffffff;
        background-color: #4174FD;
      }

    }
  }
}
</style>
